import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Layout, notification, PageHeader, Row, Switch, Typography, Collapse } from 'antd'
import idx from 'idx'
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import { fetchContentOpsById, resetEventActionStatus, invalidateCFCache, updateContentOpsById } from '~actions'
import { AddToCalender, BuyBox, EventInfo, EDPHeroInfo, EventDetail, InternalSearchOptimization, PageMetaInfoWithEditor, RecommendationsSelector, DatafieldGallery, ResultModal, PriorSameArtistEdpRedirects } from '~components'
import { getCurrentUser } from '~context'
import { Checkbox, MultiSelectDropdown, Spinner } from '~stories'
import { getEventPulldownValue, getFileName, getUTCTime } from '~utils'

import { MSG_CF } from '../../constants'
import styles from './EditContentOps.module.css'

const PAGE_TITLE = 'Manage Event'
const { Content } = Layout
const { Paragraph, Title } = Typography

const FORMATTER = {
  DATE: 'MM/DD/YYYY',
  TIME: 'HH:mm:ss'
}
const TBA = 'TBA'

const END_TIME_OF_DAY = '23:59:59'
const MAX_PULL_DOWN_DAYS_FOR_POSTPONED_EVENT = 180
const ERROR_MESSAGES = {
  DATA_FIELD_ERR: 'Missing required attributes in data fields',
  PUBLISH_WARNING: 'Changes to publish status will not be saved until you click update.',
  SPOTIFY_URL_ERR: 'Please provide valid URL for Spotify playlist.'
}
const { REACT_APP_STAGE } = process.env

const isArrayContains = (strArray, itemsToCheck) => {
  return itemsToCheck.some(item => strArray.includes(item))
}

const EditContentOps = ({ edpRedirectSummary, event, fetchContentOps, route, resetEventActionStatus, updateContentOpsById, updateMessage, updateStatus }) => {
  const eventInfoSectionRef = useRef(null)
  const callToActionSectionRef = useRef(null)
  const assetsSectionRef = useRef(null)
  const eventRecommendationSectionRef = useRef(null)
  const searchSectionRef = useRef(null)
  const menuRef = useRef(null)
  const [allArtists, setAllArtists] = useState([])
  const [existingEvent, setExistingEvent] = useState(null)
  const [isDataLoaded, setIsDataLoaded] = useState(true)
  const [isDataUpdated, setIsDataUpdated] = useState(true)
  const [buyTicketErr, setBuyTicketErr] = useState(false)
  const [allKnowBeforeYouGo, setAllKnowBeforeYouGo] = useState([])
  const [allVenueFAQs, setAllVenueFAQs] = useState([])
  const [allGenres, setAllGenres] = useState([])
  const [allVenueBenefits, setAllVenueBenefits] = useState([])
  const [allSubscribe, setAllSubscribe] = useState([])
  const [allShopMerchandise, setAllShopMerchandise] = useState([])
  const [allViewSeatingChart, setAllViewSeatingChart] = useState([])
  const { access_token: accessToken, userDetails: { isContentEditor = false } = {} } = getCurrentUser()
  const [promotedEvents, setPromotedEvents] = useState([])
  const [publish, setPublish] = useState()
  const [selectedGenres, setSelectedGenres] = useState([])
  const [allEvents, setAllEvents] = useState([])
  const [eventDetails, setEventDetails] = useState(null)
  const [promotedArtists, setPromotedArtists] = useState([])
  const [selectedCategories, setSelectedCategories] = useState([])
  const [selectedFlags, setSelectedFlags] = useState([])
  const [selectedSphereFlags, setSelectedSphereFlags] = useState([])
  const [selectedRoxFlags, setSelectedRoxFlags] = useState([])
  const [selectedRoxGroupFlags, setSelectedRoxGroupFlags] = useState([])
  const [allSubCategories, setAllSubCategories] = useState([])
  const [selectedSubCategories, setSelectedSubCategories] = useState([])
  const [allRoxFlags, setAllRoxFlags] = useState([])
  const [allRoxGroupFlags, setAllRoxGroupFlags] = useState([])
  const [gallery, setGallery] = useState([])
  const [selectedPriorEdpIds, setSelectedPriorEdpIds] = useState([])
  const [edpRedirectPermanent, setEdpRedirectPermanent] = useState(true)

  useEffect(() => {
    const tmEventId = idx(route, _ => _.match.params.id)
    if (tmEventId) {
      setIsDataLoaded(false)
      fetchContentOps(tmEventId)
    }
  }, [route, fetchContentOps])

  useEffect(() => {
    if (event && event.id) {
      setAllKnowBeforeYouGo(event.allKnowBeforeYouGoDFields)
      setAllVenueFAQs(event.allVenueFAQsDFields)
      // setAllEventDetails(event.allEventDetailsDFields)
      setAllVenueBenefits(event.allVenueBenefitsDFields)
      setAllVenueBenefits(event.allVenueBenefitsDFields)
      setAllSubscribe(event.allSubscribeDFields)
      setPromotedEvents(event.relatedEvents)
      setAllShopMerchandise(event.allShopMerchandiseDFields)
      setAllViewSeatingChart(event.allViewSeatingChartDFields)
      // setAllGalleryDFields(event.allGalleryDFields)
      setPublish(event.publish)
      const selectedGenres = event.genres.map(({ name }) => name) || []
      setSelectedGenres(selectedGenres)
      setAllGenres(event.allGenres || [])
      const selectedCategories = event?.category.map(({ name }) => name) || []
      const selectedFlags = event?.flags ? event?.flags.map(({ title }) => title) : []
      const selectedSphereFlags = event?.sphereFlags ? event?.sphereFlags.map(({ title }) => title) : []
      const selectedRoxFlags = event?.roxFlags ? event?.roxFlags.map(({ title }) => title) : []
      const selectedRoxGroupFlags = event?.roxGroupFlags ? event?.roxGroupFlags.map(({ title }) => title) : []
      const allSubCategories = event?.allCategories.map(eventCategory => eventCategory.sub_category).flat()
      const selectedSubCategories = event?.subCategory.map(({ name }) => name) || []
      const galleryList = event?.gallery || []

      const eventDetail = event?.eventDetails || {
        header: '',
        details: '',
        icon: {
          alt: '',
          url: ''
        }
      }
      setEventDetails(eventDetail)
      setAllEvents(event.allUpsellEvents)
      setPromotedArtists(event.artists || [])
      setExistingEvent({
        ...event,
        dbPublishStatus: event.publish,
        dbPostponedStatus: event.postponed,
        dbStatus: event.status,
        buyBoxCallToActions: {
          ...event.buyBoxCallToActions,
          buy_tickets_url: event?.hostUrl,
          buy_group_tickets: event?.buyBoxCallToActions?.buy_group_tickets || {},
          buy_multi_event_tickets_url: event?.buyBoxCallToActions?.buy_multi_event_tickets_url || ''
        }
      })
      setSelectedCategories(selectedCategories)
      setSelectedFlags(selectedFlags)
      setSelectedSphereFlags(selectedSphereFlags)
      setSelectedRoxFlags(selectedRoxFlags)
      setSelectedRoxGroupFlags(selectedRoxGroupFlags)
      setSelectedSubCategories(selectedSubCategories)
      setAllSubCategories(allSubCategories)
      const { roxFlagsList = [], roxGroupsFlagsList = [] } = event
      setAllRoxFlags(roxFlagsList)
      setAllRoxGroupFlags(roxGroupsFlagsList)
      setGallery(galleryList)
      setAllArtists(event.allArtists)
      setSelectedPriorEdpIds([])
      setEdpRedirectPermanent(true)
      setIsDataLoaded(true)
    }
  }, [event])

  useEffect(() => {
    if (updateStatus && updateMessage) {
      setIsDataLoaded(false)
      setIsDataUpdated(false)
      if (edpRedirectSummary?.created?.length) {
        notification.info({
          message: `Created ${edpRedirectSummary.created.length} redirect(s) from prior EDP URLs to this page.`
        })
      }
      if (edpRedirectSummary?.replaced?.length) {
        notification.info({
          message: `Updated ${edpRedirectSummary.replaced.length} existing redirect(s) to point to this page.`
        })
      }
    } else if (!updateStatus && updateMessage) {
      setIsDataLoaded(false)
      setIsDataUpdated(true)
      notification.error({ message: updateMessage })
      resetEventActionStatus()
    }
  }, [updateStatus, updateMessage, resetEventActionStatus, edpRedirectSummary])

  const handleMenuClick = (key) => {
    if (key === 'eventInfoSectionRef') {
      eventInfoSectionRef?.current?.scrollIntoView({ behavior: 'smooth' })
    } else if (key === 'callToActionSectionRef') {
      callToActionSectionRef?.current?.scrollIntoView({ behavior: 'smooth' })
    } else if (key === 'assetsSectionRef') {
      assetsSectionRef?.current?.scrollIntoView({ behavior: 'smooth' })
    } else if (key === 'eventRecommendationSectionRef') {
      eventRecommendationSectionRef?.current?.scrollIntoView({ behavior: 'smooth' })
    } else if (key === 'searchSectionRef') {
      searchSectionRef?.current?.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const handleInternalSearch = (tags = []) => {
    const updatedEvent = {
      ...existingEvent,
      internalSearch: [
        ...tags
      ]
    }
    setExistingEvent(updatedEvent)
  }

  const handleShowInInternalSearchChange = (event) => {
    setExistingEvent({
      ...existingEvent,
      showInInternalSearch: event.target.checked
    })
  }

  const handleShowInGoogleSearchChange = (event) => {
    setExistingEvent({
      ...existingEvent,
      showInGoogleSearch: event.target.checked
    })
  }

  const handleBuyGroupTickets = (event) => {
    const { buyBoxCallToActions } = existingEvent
    const { buy_group_tickets: buyGroupTickets = {} } = buyBoxCallToActions
    const showCTA = !!((event.target.value) && event.target.value.length > 0)
    const updatedEvent = {
      ...existingEvent,
      buyBoxCallToActions: {
        ...buyBoxCallToActions,
        buy_group_tickets: {
          ...buyGroupTickets,
          url: event.target.value,
          showCTA
        }
      }
    }
    setExistingEvent(updatedEvent)
  }

  const handleEventDetailDescriptionChange = (htmlDescription) => {
    const updatedEvent = {
      ...existingEvent,
      htmlDescription
    }
    setExistingEvent(updatedEvent)
  }

  const handleEventDetailHeaderChange = (event) => {
    const {
      eventDetails = {
        header: '',
        details: '',
        icon: {
          alt: '',
          url: ''
        }
      }
    } = existingEvent
    const updatedEvent = {
      ...existingEvent,
      eventDetails: {
        ...eventDetails,
        header: event.target.value
      }
    }
    setEventDetails(updatedEvent.eventDetails)
    setExistingEvent(updatedEvent)
  }

  const onHeadlinerClick = selectedItem => {
    const artists = [...promotedArtists]
    const updatedArtists = artists.map(artist => (artist.id === selectedItem.id ? { ...selectedItem } : artist))
    setPromotedArtists(updatedArtists)
  }

  const handleEventDetailIconUpdate = (url) => {
    const {
      eventDetails = {
        header: '',
        details: '',
        icon: {
          alt: '',
          url: ''
        }
      }
    } = existingEvent
    const { icon = {} } = eventDetails

    const alt = getFileName(url)
    const updatedEvent = {
      ...existingEvent,
      eventDetails: {
        ...eventDetails,
        icon: {
          ...icon,
          url,
          alt
        }
      }
    }
    setEventDetails(updatedEvent.eventDetails)
    setExistingEvent(updatedEvent)
  }

  const handleDefaultImageUpdate = (url) => {
    const {
      defaultImage = {
        url: '',
        height: null,
        weight: null
      }
    } = existingEvent
    const updatedEvent = {
      ...existingEvent,
      defaultImage: {
        ...defaultImage,
        url
      }
    }
    setEventDetails(updatedEvent.eventDetails)
    setExistingEvent(updatedEvent)
  }

  const handleEventDetailNotificationChange = (event) => {
    const {
      eventDetails = {
        header: '',
        details: '',
        icon: {
          alt: '',
          url: ''
        }
      }
    } = existingEvent
    const updatedEvent = {
      ...existingEvent,
      eventDetails: {
        ...eventDetails,
        details: event.target.value
      }
    }
    setEventDetails(updatedEvent.eventDetails)
    setExistingEvent(updatedEvent)
  }

  const handleBuyMultiDayTickets = (event) => {
    const { buyBoxCallToActions } = existingEvent
    const updatedEvent = {
      ...existingEvent,
      buyBoxCallToActions: {
        ...buyBoxCallToActions,
        buy_multi_event_tickets_url: event.target.value
      }
    }
    setExistingEvent(updatedEvent)
  }

  const setPublishStatus = publish => {
    setPublish(publish)
    notification.warning({ message: ERROR_MESSAGES.PUBLISH_WARNING })
    const updatedEvent = { ...existingEvent, publish }
    setExistingEvent(updatedEvent)
  }

  const handleBuyTickets = (event) => {
    const { buyBoxCallToActions } = existingEvent
    setBuyTicketErr(false)
    if (!event.target.value) {
      setBuyTicketErr(true)
    }
    const updatedEvent = {
      ...existingEvent,
      hostUrl: event.target.value,
      buyBoxCallToActions: {
        ...buyBoxCallToActions,
        buy_tickets_url: event.target.value
      }
    }
    setExistingEvent(updatedEvent)
  }

  const handleAddToCalendar = addToCalendar => {
    const updatedEvent = { ...existingEvent, addToCalendar }
    setExistingEvent(updatedEvent)
  }

  const handleKnowBeforeYouGoChange = (selectedItem) => {
    const { dataFields } = existingEvent
    const updatedEvent = {
      ...existingEvent,
      dataFields: {
        ...dataFields,
        knowBeforeYouGo: selectedItem
      }
    }
    setExistingEvent(updatedEvent)
  }

  const handleVenueFAQsChange = (selectedItem) => {
    const { dataFields } = existingEvent
    const updatedEvent = {
      ...existingEvent,
      dataFields: {
        ...dataFields,
        venue_faqs: selectedItem
      }
    }
    setExistingEvent(updatedEvent)
  }

  const handleVenueBenefits = (selectedItem) => {
    const { dataFields } = existingEvent
    const updatedEvent = {
      ...existingEvent,
      dataFields: {
        ...dataFields,
        venue_benefits: selectedItem
      }
    }
    setExistingEvent(updatedEvent)
  }

  const handleSubscribeChange = (selectedItem) => {
    const { dataFields } = existingEvent
    const updatedEvent = {
      ...existingEvent,
      dataFields: {
        ...dataFields,
        subscribe: selectedItem
      }
    }
    setExistingEvent(updatedEvent)
  }

  const handleShopMerchandiseChange = (selectedItem) => {
    const { dataFields } = existingEvent
    const updatedEvent = {
      ...existingEvent,
      dataFields: {
        ...dataFields,
        shop_merchandise: selectedItem
      }
    }
    setExistingEvent(updatedEvent)
  }

  const handleViewSeatingChartChange = (selectedItem) => {
    const { dataFields } = existingEvent
    const updatedEvent = {
      ...existingEvent,
      dataFields: {
        ...dataFields,
        view_seating_chart: selectedItem
      }
    }
    setExistingEvent(updatedEvent)
  }

  const handlePageMetaDescriptionChange = (description) => {
    const { pageMeta = {} } = existingEvent

    setExistingEvent({
      ...existingEvent,
      pageMeta: {
        ...pageMeta,
        description
      }
    })
  }

  const handlePageMetaHeadingChange = (event) => {
    const { pageMeta = {} } = existingEvent
    const heading = event.target.value
    const { text } = pageMeta
    const showSEO = !!((heading && heading.length > 0) && (text && text.length > 0))

    setExistingEvent({
      ...existingEvent,
      pageMeta: {
        ...pageMeta,
        heading,
        should_show_seo: showSEO
      }
    })
  }

  const handlePageMetaKeywordsChange = (event) => {
    const keywords = event.target.value
    const { pageMeta = {} } = existingEvent

    setExistingEvent({
      ...existingEvent,
      pageMeta: {
        ...pageMeta,
        keywords
      }
    })
  }

  const handlePageMetaShowSEOChange = (event) => {
    const showSEO = event.target.checked
    const { pageMeta = {} } = existingEvent

    setExistingEvent({
      ...existingEvent,
      pageMeta: {
        ...pageMeta,
        should_show_seo: showSEO
      }
    })
  }

  const handlePageMetaTextChange = (text) => {
    const { pageMeta = {} } = existingEvent

    const { heading } = pageMeta
    const showSEO = !!((heading && heading.length > 0) && (text && text.length > 0))

    setExistingEvent({
      ...existingEvent,
      pageMeta: {
        ...pageMeta,
        text,
        should_show_seo: showSEO
      }
    })
  }

  const handleEventEndDateUpdate = date => {
    const endDate = date.startOf('day')
    const updatedEvent = { ...existingEvent, endDate }
    setExistingEvent(updatedEvent)
  }

  const handleEventPullDownTimeUpdate = date => {
    const pullDownFromSystem = date.toISOString()
    const updatedEvent = { ...existingEvent, pullDownFromSystem }
    setExistingEvent(updatedEvent)
  }

  const handleDoorOpenTimeUpdate = selectedDate => {
    const doorOpenTime = selectedDate ? selectedDate.format(FORMATTER.TIME) : TBA
    const updatedEvent = { ...existingEvent, doorOpenTime }
    setExistingEvent(updatedEvent)
  }

  const handlePageMetaTitleChange = (event) => {
    const title = event.target.value
    const { pageMeta } = existingEvent

    setExistingEvent({
      ...existingEvent,
      pageMeta: {
        ...pageMeta,
        title
      }
    })
  }

  const handleCTALabelChange = (event) => {
    const externalCTALabel = event.target.value
    const { externalHeroCta: externalCTA = {} } = existingEvent
    const { external_cta_url: url } = externalCTA

    const showCTA = !!((externalCTALabel && externalCTALabel.length > 0) && (url && url.length > 0))
    setExistingEvent({
      ...existingEvent,
      externalHeroCta: {
        ...externalCTA,
        external_cta_label: externalCTALabel,
        should_show_external_cta: showCTA
      }
    })
  }

  const handleNameUpdate = event => {
    const name = event.target.value
    const updatedEvent = { ...existingEvent, name }
    setExistingEvent(updatedEvent)
  }

  const handleArtistTMUrl = event => {
    const artistTmUrl = event.target.value
    const updatedEvent = { ...existingEvent, artistTmUrl }
    setExistingEvent(updatedEvent)
  }

  const handleEnableStickyCta = event => {
    const enableStickyCta = event.target.checked
    setExistingEvent({ ...existingEvent, enableStickyCta })
  }

  const handleSlug = event => {
    const slug = event.target.value
    const updatedEvent = { ...existingEvent, slug }
    setExistingEvent(updatedEvent)
  }

  const handleSubtitleUpdate = event => {
    const subTitle = event.target.value
    const updatedEvent = { ...existingEvent, subTitle }
    setExistingEvent(updatedEvent)
  }

  const handleTourUpdate = event => {
    const tourName = event.target.value
    const updatedEvent = { ...existingEvent, tourName }
    setExistingEvent(updatedEvent)
  }

  const handleSpecialGuestUpdate = event => {
    const specialGuest = event.target.value
    const updatedEvent = { ...existingEvent, specialGuest }
    setExistingEvent(updatedEvent)
  }

  const handleSubCategoriesUpdate = selectedItems => {
    const subCategory = selectedItems.map(name => ({ name }))
    setSelectedSubCategories(selectedItems)

    const subCategoryList = subCategory.map(item => item.name)
    const selectedSubCategories = allSubCategories.filter(eventCategory => subCategoryList.includes(eventCategory.name))
    const selectedEventSubCategories = selectedSubCategories?.map(subCategory => subCategory.value)
    const selectedEventType = selectedEventSubCategories?.includes('knicks') ? 'knicks' : selectedEventSubCategories?.includes('rangers') ? 'rangers'
      : isArrayContains(['combat-sports-events', 'college-sports', 'wwe', 'bull-riding', 'darts', 'other-sports'], selectedEventSubCategories)
        ? 'other-sports' : 'other-events'

    const updatedEvent = {
      ...existingEvent,
      sub_category: [
        ...selectedSubCategories
      ],
      eventType: [
        selectedEventType
      ]
    }
    setExistingEvent(updatedEvent)
  }

  const handleEventStatus = status => {
    const { startDate, artists, startTime, timezone } = existingEvent
    const eventStartTime = (startTime === TBA) ? TBA : startTime
    const updatedStartDate = status === 'postponed' ? moment.tz(startDate, timezone).add(MAX_PULL_DOWN_DAYS_FOR_POSTPONED_EVENT, 'days').format(FORMATTER.DATE) : startDate
    const pullDownFromSystem = getEventPulldownValue(updatedStartDate, eventStartTime, artists, timezone)
    const statusText = status === 'postponed' ? 'Postponed' : ''
    const eventStatus = status === 'postponed' ? {
      postponed: true,
      pullDownFromSystem,
      statusText,
      status
    } : {
      status
    }
    const updatedEvent = {
      ...existingEvent,
      ...eventStatus
    }
    setExistingEvent(updatedEvent)
  }

  const handlePostponed = e => {
    if (e.target.checked) {
      handleEventStatus('postponed')
    } else {
      const revertStatus = existingEvent.dbStatus === 'postponed' ? 'active' : existingEvent.dbStatus
      setExistingEvent({ ...existingEvent, postponed: false, status: revertStatus, statusText: '' })
    }
  }

  const handleFlagsUpdate = selectedItem => {
    setSelectedFlags(selectedItem)
    const selectedFlags = existingEvent.allFlags.filter(flag => [selectedItem].includes(flag.title))

    const updatedEvent = {
      ...existingEvent,
      flags: [
        ...selectedFlags
      ]
    }
    setExistingEvent(updatedEvent)
  }

  const handleSphereFlagsUpdate = selectedItem => {
    setSelectedSphereFlags(selectedItem)
    const selectedFlags = existingEvent.allFlags.filter(flag => [selectedItem].includes(flag.title))

    const updatedEvent = {
      ...existingEvent,
      sphereFlags: [
        ...selectedFlags
      ]
    }
    setExistingEvent(updatedEvent)
  }

  const handleRoxFlagsUpdate = selectedItem => {
    setSelectedRoxFlags(selectedItem)
    const selectedFlags = existingEvent.roxFlagsList.filter(flag => [selectedItem].includes(flag.title))

    const updatedEvent = {
      ...existingEvent,
      rox_flags: [
        ...selectedFlags
      ]
    }
    setExistingEvent(updatedEvent)
  }

  const handleRoxGroupFlagsUpdate = selectedItem => {
    setSelectedRoxGroupFlags(selectedItem)
    const selectedFlags = existingEvent.roxGroupFlags.filter(flag => [selectedItem].includes(flag.title))

    const updatedEvent = {
      ...existingEvent,
      rox_group_flags: [
        ...selectedFlags
      ]
    }
    setExistingEvent(updatedEvent)
  }

  const handleEventTypeUpdate = selectedItems => {
    const eventType = selectedItems.map(type => type)
    const updatedEvent = { ...existingEvent, eventType: eventType }
    setExistingEvent(updatedEvent)
  }

  const handleStartTimeUpdate = selectedDate => {
    const startTime = selectedDate ? selectedDate.format(FORMATTER.TIME) : TBA
    const updatedEvent = { ...existingEvent, startTime }
    setExistingEvent(updatedEvent)
  }

  const handleSpanMultipleDaysUpdate = event => {
    const status = event.target.checked
    const updatedEvent = { ...existingEvent, spanMultipleDays: status }
    setExistingEvent(updatedEvent)
  }

  const handleShouldShowGroupTicketsCTA = event => {
    const status = event.target.checked
    const { buyBoxCallToActions } = existingEvent
    const { buy_group_tickets: buyGroupTickets = {} } = buyBoxCallToActions
    const updatedEvent = {
      ...existingEvent,
      buyBoxCallToActions: {
        ...buyBoxCallToActions,
        buy_group_tickets: {
          ...buyGroupTickets,
          showCTA: status
        }
      }
    }
    setExistingEvent(updatedEvent)
  }

  const handleEventArtist = selectedItems => {
    setPromotedArtists(selectedItems)
    const selectedArtists = existingEvent.allArtists.filter(artist => selectedItems?.includes(artist.title || artist.id))

    const updatedEvent = {
      ...existingEvent,
      artists: [
        ...selectedArtists
      ]
    }
    setExistingEvent(updatedEvent)
  }

  const handleEnablePresale = (event) => {
    const updatedVenue = { ...existingEvent, enablePresale: event.target.checked }
    setExistingEvent(updatedVenue)
  }

  const handleCategoriesUpdate = selectedItems => {
    const category = selectedItems.map(name => ({ name }))
    setSelectedCategories(selectedItems)
    const categoryList = category.map(item => item.name)
    const selectedCategories = existingEvent.allCategories.filter(eventCategory => categoryList.includes(eventCategory.name))

    const updatedEvent = {
      ...existingEvent,
      category: [
        ...selectedCategories
      ]
    }
    setExistingEvent(updatedEvent)
  }

  const handleCTAUrlChange = (event) => {
    const externalCTAUrl = event.target.value
    const { externalHeroCta: externalCTA = {} } = existingEvent

    const { external_cta_label: label } = externalCTA
    const showCTA = !!((externalCTAUrl && externalCTAUrl.length > 0) && (label && label.length > 0))

    setExistingEvent({
      ...existingEvent,
      externalHeroCta: {
        ...externalCTA,
        external_cta_url: externalCTAUrl,
        should_show_external_cta: showCTA
      }
    })
  }

  const handleShowExternalCTAChange = (event) => {
    const showCTA = event.target.checked
    const { externalHeroCta: externalCTA = {} } = existingEvent

    setExistingEvent({
      ...existingEvent,
      externalHeroCta: {
        ...externalCTA,
        should_show_external_cta: showCTA
      }
    })
  }

  const handleHeroImageUrlUpdate = (imageUrl) => {
    const { hero = {} } = existingEvent

    const alt = getFileName(imageUrl)
    setExistingEvent({
      ...existingEvent,
      hero: {
        ...hero,
        alt,
        url: imageUrl
      }
    })
  }

  const handleGenresUpdate = selectedItems => {
    const genres = selectedItems.map(name => ({ name }))
    const updatedEvent = { ...existingEvent, genres }
    setExistingEvent(updatedEvent)
    setSelectedGenres(selectedItems)
  }

  const getDateTime = (startDate, startTime, timezone) => {
    let dateTime = ''
    const formattedStartDate = startDate.split('T')[0]
    if (startTime && startTime !== TBA) {
      dateTime = getUTCTime(formattedStartDate, startTime, timezone)
    } else {
      dateTime = getUTCTime(formattedStartDate, END_TIME_OF_DAY, timezone)
    }
    return dateTime
  }

  const handleSubmit = async () => {
    setBuyTicketErr(false)
    if (!existingEvent?.buyBoxCallToActions?.buy_tickets_url) {
      setBuyTicketErr(true)
      return
    }
    const { eventDetails, startDate, startTime, timezone, series, slug, category, gallery = [] } = existingEvent
    const dateTime = getDateTime(startDate, startTime, timezone)
    const relatedEvents = promotedEvents.map(({ id }) => id)
    const [eventSeries] = series
    const artistsList = promotedArtists.map(({ id, title, is_headliner: isHeadLiner }) => ({
      id,
      name: title,
      is_headliner: isHeadLiner
    }))
    const selectedCategory = category.map(({ name, value }) => ({
      name,
      value
    }))

    const selectedFlag = existingEvent.flags.filter(flag => selectedFlags?.includes(flag.title))
    const selectedSphereFlag = existingEvent?.sphereFlagsList.filter(flag => selectedSphereFlags?.includes(flag.title))
    const selectedRoxFlag = allRoxFlags.filter(flag => selectedRoxFlags?.includes(flag.title))
    const selectedRoxGroupFlag = allRoxGroupFlags.filter(flag => selectedRoxGroupFlags?.includes(flag.title))

    const selectedSubCategoriesList = allSubCategories.filter(eventCategory => selectedSubCategories.includes(eventCategory.name))

    const dataFields = {
      knowBeforeYouGo: existingEvent?.dataFields?.knowBeforeYouGo,
      venue_faqs: existingEvent?.dataFields?.venue_faqs,
      venue_benefits: existingEvent?.dataFields?.venue_benefits,
      subscribe: existingEvent?.dataFields?.subscribe,
      view_seating_chart: existingEvent?.dataFields?.view_seating_chart,
      shop_merchandise: existingEvent?.dataFields?.shop_merchandise
    }

    setIsDataUpdated(false)
    const { id } = existingEvent
    const edpRedirectPlan = publish && selectedPriorEdpIds.length > 0 && isContentEditor
      ? { priorEventIds: selectedPriorEdpIds, permanent: edpRedirectPermanent }
      : undefined
    const eventObj = {
      ...existingEvent,
      dataFields,
      relatedEvents,
      artists: artistsList,
      category: selectedCategory,
      eventDetails,
      dateTime,
      slug,
      flags: selectedFlag,
      sphere_flags: selectedSphereFlag,
      roxFlags: selectedRoxFlag,
      roxGroupFlags: selectedRoxGroupFlag,
      seriesId: eventSeries.id,
      subCategory: selectedSubCategoriesList,
      gallery,
      ...(edpRedirectPlan && { edpRedirectPlan })
    }

    console.log(eventObj, eventSeries)

    updateContentOpsById(id, eventObj, accessToken)

    if (REACT_APP_STAGE === 'production') {
      await invalidateCFCache(MSG_CF.PROD, `/events-tickets${slug}`, true)
    } else {
      await invalidateCFCache(MSG_CF.NON_PROD, `/events-tickets${slug}`, true)
    }
  }

  const setDontOverrideRecommendations = event => {
    const status = event.target.checked
    const updatedEvent = { ...existingEvent, doNotOverrideRecommendations: status }
    setExistingEvent(updatedEvent)
  }

  const addNewGallery = (event) => {
    event.stopPropagation()
    const { gallery = [] } = existingEvent

    gallery.push({
      title: '',
      src: '',
      alt: '',
      mediaType: '',
      subtitle: ''
    })
    setGallery(gallery)
    setExistingEvent({
      ...existingEvent,
      gallery
    })
  }

  const deleteAllGalleryFlexModule = (event) => {
    event.stopPropagation()

    setGallery([])
    setExistingEvent({
      ...existingEvent,
      gallery: []
    })
  }

  const deleteGallery = (event, dataFieldGalleryIndex) => {
    event.stopPropagation()

    const clonedGalleries = [...gallery]

    if (dataFieldGalleryIndex !== -1) {
      clonedGalleries.splice(dataFieldGalleryIndex, 1)
    }
    setGallery(clonedGalleries)
    setExistingEvent({
      ...existingEvent,
      gallery: clonedGalleries
    })
  }

  const handleGalleryImageAltChange = (event, galleryIndex) => {
    const { gallery = [] } = existingEvent
    const updatedGallery = [
      ...gallery.slice(0, galleryIndex),
      {
        ...gallery[galleryIndex],
        alt: event.target.value
      },
      ...gallery.slice(galleryIndex + 1)
    ]
    setGallery(updatedGallery)
    setExistingEvent({
      ...existingEvent,
      gallery: updatedGallery
    })
  }

  const handleGalleryImageUrlUpdate = (imageUrl, galleryIndex) => {
    const { gallery = [] } = existingEvent

    const updatedGallery = [
      ...gallery.slice(0, galleryIndex),
      {
        ...gallery[galleryIndex],
        src: imageUrl
      },
      ...gallery.slice(galleryIndex + 1)
    ]
    setGallery(updatedGallery)
    setExistingEvent({
      ...existingEvent,
      gallery: updatedGallery
    })
  }

  const handleGalleryChange = (updatedGallery) => {
    setGallery(updatedGallery)
    setExistingEvent({
      ...existingEvent,
      gallery: updatedGallery
    })
  }

  const handleGallerySubTitleChange = (event, galleryIndex) => {
    const { gallery = [] } = existingEvent
    const updatedGallery = [
      ...gallery.slice(0, galleryIndex),
      {
        ...gallery[galleryIndex],
        subtitle: event.target.value
      },
      ...gallery.slice(galleryIndex + 1)
    ]
    setGallery(updatedGallery)
    setExistingEvent({
      ...existingEvent,
      gallery: updatedGallery
    })
  }

  const handleGalleryTitleChange = (event, galleryIndex) => {
    const { gallery = [] } = existingEvent
    const updatedGallery = [
      ...gallery.slice(0, galleryIndex),
      {
        ...gallery[galleryIndex],
        title: event.target.value
      },
      ...gallery.slice(galleryIndex + 1)
    ]
    setGallery(updatedGallery)
    setExistingEvent({
      ...existingEvent,
      gallery: updatedGallery
    })
  }

  const handleGalleryMediaChange = (selectedItems, galleryIndex) => {
    const { gallery = [] } = existingEvent
    const updatedGallery = [
      ...gallery.slice(0, galleryIndex),
      {
        ...gallery[galleryIndex],
        mediaType: selectedItems
      },
      ...gallery.slice(galleryIndex + 1)
    ]
    setGallery(updatedGallery)
    setExistingEvent({
      ...existingEvent,
      gallery: updatedGallery
    })
  }

  const publishSwitch = <Switch checked={publish} checkedChildren="Publish" defaultChecked onChange={setPublishStatus} unCheckedChildren="UnPublish" />
  const genOverrideFlag = () => {
    return <div onClick={ e => e.stopPropagation() }>
      <Checkbox
        checked={existingEvent?.doNotOverrideRecommendations}
        isInline
        label='DO NOT OVERRIDE RECOMMENDATIONS'
        onChange={setDontOverrideRecommendations}
      />
    </div>
  }

  const submitButton = <Button className={styles.updateActionButton} loading={!isDataUpdated} onClick={handleSubmit} type='primary'>
    Update
  </Button>

  const addGallery = gallery && gallery.length < 10
    ? <Button className={styles.updateActionButton} onClick={addNewGallery} type='primary'>Add Gallery</Button>
    : null

  const deleteAllGallery = gallery && gallery.length > 0
    ? <Button className={styles.deleteActionButton} onClick={deleteAllGalleryFlexModule} type='danger'>Delete All</Button>
    : null

  const goToListEventsButton = (
    <Route key="listEvents" render={({ history }) => (
      <Button
        onClick={() => {
          resetEventActionStatus()
          history.push('/events')
        }}
        type="primary"
      >
        Go to Events List
      </Button>
    )} />
  )

  const editEventsButton = (
    <Route key="editEvent" render={() => (
      <Button
        onClick={() => {
          resetEventActionStatus()
          window.location.reload()
        }}
        type="primary"
      >
        Edit Event
      </Button>
    )} />
  )

  return (
    <Layout className={styles.eventLayout}>
      {existingEvent && <><ul ref={menuRef} className={styles.menu} onClick={() => {}}>
        <li key="eventInfoSectionRef" onClick={() => handleMenuClick('eventInfoSectionRef')}>Event Information</li>
        <li key="callToActionSectionRef" onClick={() => handleMenuClick('callToActionSectionRef')} >Buy Box & Call-to-Action</li>
        <li key="assetsSectionRef" onClick={() => handleMenuClick('assetsSectionRef')} >Photos & Videos</li>
        <li key="eventRecommendationSectionRef" onClick={() => handleMenuClick('eventRecommendationSectionRef')} >Recommended Events</li>
        <li key="searchSectionRef" onClick={() => handleMenuClick('searchSectionRef')} >Search Engine Optimization</li>
      </ul>
      <PageHeader className={styles.headline} extra={[publishSwitch, submitButton]} title={PAGE_TITLE} />
      <Content className={styles.contentContainer}>
        <div ref={eventInfoSectionRef}>
          {existingEvent && existingEvent.id && <EventInfo
            allArtists={allArtists}
            allSubCategories={allSubCategories}
            event={existingEvent}
            handleArtistTMUrl={handleArtistTMUrl}
            handleCategoriesUpdate={handleCategoriesUpdate}
            handleDoorOpenTimeUpdate={handleDoorOpenTimeUpdate}
            handleEnableStickyCta={handleEnableStickyCta}
            handleEventArtist={handleEventArtist}
            handleEventDetailIconUpdate={handleDefaultImageUpdate}
            handleEventEndDateUpdate={handleEventEndDateUpdate}
            handleEventPullDownTimeUpdate={handleEventPullDownTimeUpdate}
            handleEventStatus={handleEventStatus}
            handleEventTypeUpdate={handleEventTypeUpdate}
            handleFlagsUpdate={handleFlagsUpdate}
            handleNameUpdate={handleNameUpdate}
            handlePostponed={handlePostponed}
            handleRoxFlagsUpdate={handleRoxFlagsUpdate}
            handleRoxGroupFlagsUpdate={handleRoxGroupFlagsUpdate}
            handleSlug={handleSlug}
            handleSpanMultipleDaysUpdate={handleSpanMultipleDaysUpdate}
            handleSpecialGuestUpdate={handleSpecialGuestUpdate}
            handleSphereFlagsUpdate={handleSphereFlagsUpdate}
            handleStartTimeUpdate={handleStartTimeUpdate}
            handleSubCategoriesUpdate={handleSubCategoriesUpdate}
            handleSubtitleUpdate={handleSubtitleUpdate}
            handleTourUpdate={handleTourUpdate}
            onHeadlinerClick={onHeadlinerClick}
            promotedArtists={promotedArtists}
            selectedCategories={selectedCategories}
            selectedFlags={selectedFlags}
            selectedRoxFlags={selectedRoxFlags}
            selectedRoxGroupFlags={selectedRoxGroupFlags}
            selectedSphereFlags={selectedSphereFlags}
            selectedSubCategories={selectedSubCategories}
            setAllArtists={setAllArtists}
            setPromotedArtists={setPromotedArtists}

          />}
          {existingEvent && existingEvent.id && event?.priorPublishedSameArtistEdps?.length > 0 && (
            <PriorSameArtistEdpRedirects
              currentSlug={existingEvent.slug}
              disabled={!isContentEditor}
              edpRedirectPermanent={edpRedirectPermanent}
              priorRows={event.priorPublishedSameArtistEdps}
              publish={publish}
              selectedPriorEdpIds={selectedPriorEdpIds}
              setEdpRedirectPermanent={setEdpRedirectPermanent}
              setSelectedPriorEdpIds={setSelectedPriorEdpIds}
            />
          )}
        </div>
        <div ref={callToActionSectionRef}>
          {existingEvent?.buyBoxCallToActions && <BuyBox
            buyGroupTicket={existingEvent?.buyBoxCallToActions?.buy_group_tickets?.url || ''}
            buyTicketErr={buyTicketErr}
            buyTicketUrl={existingEvent?.buyBoxCallToActions?.buy_tickets_url}
            handleShouldShowGroupTicketsCTA={handleShouldShowGroupTicketsCTA}
            multiTicketUrl={existingEvent?.buyBoxCallToActions?.buy_multi_event_tickets_url || ''}
            setBuyGroupTicket={handleBuyGroupTickets}
            setBuyTicketErr={setBuyTicketErr}
            setBuyTicketUrl={handleBuyTickets}
            setMultiTicketUrl={handleBuyMultiDayTickets}
            // shouldShowGroupTicketsCTA={existingEvent?.buyBoxCallToActions?.buy_group_tickets?.showCTA || false}
          />}
        </div>
        <div className={styles['add-to-calender-container']}>
          <Title className={styles['title-text']} level={2}>Presale</Title>
          <Card className={styles['card-container']}>
            <Row>
              <Col span={24}>
                <Checkbox
                  checked={existingEvent?.enablePresale}
                  isInline
                  label={<Title level={3}>Enable Presale</Title>}
                  onChange={handleEnablePresale}
                />
              </Col>
            </Row>
          </Card>
        </div>
        {existingEvent?.addToCalendar && <AddToCalender addToCalendar = {existingEvent?.addToCalendar} setAddToCalendar={handleAddToCalendar} />}
        <div>
          {eventDetails && existingEvent && <EventDetail
            eventDetail={eventDetails}
            handleEventDetailDescriptionChange={handleEventDetailDescriptionChange}
            handleEventDetailHeaderChange={handleEventDetailHeaderChange}
            handleEventDetailIconUpdate={handleEventDetailIconUpdate}
            handleEventDetailNotificationChange={handleEventDetailNotificationChange}
            tmDescription={existingEvent?.htmlDescription}
          />}
        </div>
        <div ref={assetsSectionRef}>
          <Card className={ styles['card-container'] } extra={[deleteAllGallery, addGallery]} title={<Title className={styles['title-text']} level={2}>Videos & Photos</Title>}>
            <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right'>
              <DatafieldGallery
                deleteGallery={deleteGallery}
                galleries={gallery}
                handleGalleryChange={handleGalleryChange}
                handleGalleryImageAltChange={handleGalleryImageAltChange}
                handleGalleryImageUrlUpdate={handleGalleryImageUrlUpdate}
                handleGalleryMediaChange={handleGalleryMediaChange}
                handleGallerySubTitleChange={handleGallerySubTitleChange}
                handleGalleryTitleChange={handleGalleryTitleChange}
                setGallery={setGallery}
              />
            </Collapse>
          </Card>
        </div>
        <div className={styles['edit-events-container']}>
          <Title className={styles.title}>Know Before You Go </Title>
          <Card className={ styles['card-container'] }>
            <Row align={'middle'} gutter={16} justify={'start'}>
              <Col><Title level={3}>(Select a venue to display planning information)</Title></Col>
            </Row>
            <Row>
              <Col span={24}>
                <MultiSelectDropdown
                  allowClear={true}
                  displayField='title'
                  dropdownOptions={allKnowBeforeYouGo}
                  handleChange={handleKnowBeforeYouGoChange}
                  selectedItems={existingEvent?.dataFields?.knowBeforeYouGo}
                  valueField='_id'
                />
              </Col>
            </Row>
          </Card>
        </div>
        <div className={styles['edit-events-container']}>
          <Title className={styles.title}>Venue FAQs</Title>
          <Card className={ styles['card-container'] }>
            <Row align={'middle'} gutter={16} justify={'start'}>
              <Col><Title level={3}>(Select a venue to display FAQs)</Title></Col>
            </Row>
            <Row>
              <Col span={24}>
                <MultiSelectDropdown
                  allowClear={true}
                  displayField='title'
                  dropdownOptions={allVenueFAQs}
                  handleChange={handleVenueFAQsChange}
                  selectedItems={existingEvent?.dataFields?.venue_faqs}
                  valueField='_id'
                />
              </Col>
            </Row>
          </Card>
        </div>
        <div className={styles['edit-events-container']}>
          <Title className={styles.title}>Venue Partner Benefits</Title>
          <Card className={ styles['card-container'] }>
            <Row align={'middle'} gutter={16} justify={'start'}>
              <Col><Title level={3}>(Select a venue to display benefits)</Title></Col>
            </Row>
            <Row>
              <Col span={24}>
                <MultiSelectDropdown
                  allowClear={true}
                  displayField='title'
                  dropdownOptions={allVenueBenefits}
                  handleChange={handleVenueBenefits}
                  selectedItems={existingEvent?.dataFields?.venue_benefits}
                  valueField='_id'
                />
              </Col>
            </Row>
          </Card>
        </div>
        <div className={styles['edit-events-container']}>
          <Title className={styles.title}>Subscribe</Title>
          <Card className={ styles['card-container'] }>
            <Row align={'middle'} gutter={16} justify={'start'}>
              <Col><Title level={3}>(Select a brand to display subscription options)</Title></Col>
            </Row>
            <Row align={'middle'} gutter={16} justify={'start'}>
              <Col span={24}>
                <MultiSelectDropdown
                  allowClear={true}
                  displayField='title'
                  dropdownOptions={allSubscribe}
                  handleChange={handleSubscribeChange}
                  selectedItems={existingEvent?.dataFields?.subscribe}
                  valueField='_id'
                />
              </Col>
            </Row>
          </Card>
        </div>
        <div className={styles['edit-events-container']}>
          <Title className={styles.title}>View Seating Chart</Title>
          <Card className={ styles['card-container'] }>
            <Row align={'middle'} gutter={16} justify={'start'}>
              <Col><Title level={3}>(Select a venue + event type combination to display seating chart)</Title></Col>
            </Row>
            <Row align={'middle'} gutter={16} justify={'start'}>
              <Col span={24}>
                <MultiSelectDropdown
                  allowClear={true}
                  displayField='title'
                  dropdownOptions={allViewSeatingChart}
                  handleChange={handleViewSeatingChartChange}
                  selectedItems={existingEvent?.dataFields?.view_seating_chart}
                  valueField='_id'
                />
              </Col>
            </Row>
          </Card>
        </div>
        <div className={styles['edit-events-container']}>
          <Title className={styles.title}>Shop Merchandise</Title>
          <Card className={ styles['card-container'] }>
            <Row align={'middle'} gutter={16} justify={'start'}>
              <Col><Title level={3}>(Select a brand to display subscription options)</Title></Col>
            </Row>
            <Row align={'middle'} gutter={16} justify={'start'}>
              <Col span={24}>
                <MultiSelectDropdown
                  allowClear={true}
                  displayField='title'
                  dropdownOptions={allShopMerchandise}
                  handleChange={handleShopMerchandiseChange}
                  selectedItems={existingEvent?.dataFields?.shop_merchandise}
                  valueField='_id'
                />
              </Col>
            </Row>
          </Card>
        </div>
        <div ref={eventRecommendationSectionRef} className={styles.recomondedEventsContainer}>
          <Title className={styles.title}>Recommended Events (e.g. People Also Viewed)</Title>
          <div className={styles['genres-wrapper']}>
            <Card className={styles['card-container']}>
              <Row align={'middle'} className={styles['title-wrapper']}>
                <Col><Title level={3}>Personalization Genres*</Title></Col>
                <Col><Title level={4}>(Select genre to populate events for people also viewed module)</Title></Col>
              </Row>
              <Row>
                <Col span={24}>
                  {existingEvent && <MultiSelectDropdown
                    allowClear={true}
                    customStyle={{ width: 450 }}
                    displayField="name"
                    dropdownOptions={allGenres}
                    handleChange={handleGenresUpdate}
                    mode='multiple'
                    placeholder='(Please select)'
                    selectedItems={selectedGenres}
                    valueField="name"
                  />}
                </Col>
              </Row>
              {selectedGenres?.length === 0 && <Paragraph className={styles['paragraph-text']}>Please select an option</Paragraph>}
            </Card>
          </div>
          {
            existingEvent && <Card extra={genOverrideFlag()} title="Personalization Events*" >
              <RecommendationsSelector
                allEvents={allEvents}
                promotedEvents={promotedEvents}
                setAllEvents={setAllEvents}
                setPromotedEvents={setPromotedEvents}
              />
            </Card>
          }
        </div>
        <div ref={searchSectionRef}>
          <Title className={styles.title}>Search Engine Optimization</Title>
          <PageMetaInfoWithEditor
            handleDescriptionChange={handlePageMetaDescriptionChange}
            handleHeadingChange={handlePageMetaHeadingChange}
            handleKeywordsChange={handlePageMetaKeywordsChange}
            handleShowSEOChange={handlePageMetaShowSEOChange}
            handleTextChange={handlePageMetaTextChange}
            handleTitleChange={handlePageMetaTitleChange}
            pageMeta={existingEvent?.pageMeta || {}}
          />
        </div>
        <div>
          <InternalSearchOptimization setTags={handleInternalSearch} tags={existingEvent?.internalSearch || []} />
          <div style={{ marginTop: 16, display: 'flex', gap: 32 }}>
            <Checkbox
              checked={existingEvent?.showInInternalSearch ?? true}
              label='Show in MSG Internal Search'
              onChange={handleShowInInternalSearchChange}
            />
            <Checkbox
              checked={existingEvent?.showInGoogleSearch ?? true}
              label='Show in Google Search'
              onChange={handleShowInGoogleSearchChange}
            />
          </div>
        </div>
        <div>
          <Title className={styles.title}>External Call-to-Actions</Title>
          <EDPHeroInfo
            handleCTALabelChange={handleCTALabelChange}
            handleCTAUrlChange={handleCTAUrlChange}
            handleImageUrlUpdate={handleHeroImageUrlUpdate}
            handleShowExternalCTAChange={handleShowExternalCTAChange}
            hero={{
              ...existingEvent?.externalHeroCta,
              ...existingEvent?.hero
            } || {}}
          />
        </div>
      </Content></>}
      <Spinner isLoading={!isDataLoaded} />
      {
        updateStatus && updateMessage && <ResultModal
          actions={[
            goToListEventsButton,
            editEventsButton
          ]}
          handleCancel={() => {
            resetEventActionStatus()
            history.push('/events')
          }}
          status="success"
          title={updateMessage}
        />
      }
    </Layout>
  )
}

EditContentOps.propTypes = {
  deleteEvent: PropTypes.func.isRequired,
  deleteMessage: PropTypes.string,
  deleteStatus: PropTypes.bool,
  edpRedirectSummary: PropTypes.object,
  event: PropTypes.object.isRequired,
  fetchContentOps: PropTypes.func.isRequired,
  resetEventActionStatus: PropTypes.func,
  route: PropTypes.object.isRequired,
  updateContentOpsById: PropTypes.func.isRequired,
  updateMessage: PropTypes.string,
  updateStatus: PropTypes.bool
}

const mapStateToProps = ({ contentOps }) => {
  console.log(contentOps)
  return {
    event: contentOps,
    updateMessage: contentOps.message,
    updateStatus: contentOps.success,
    edpRedirectSummary: contentOps.edpRedirectSummary
  }
}

const mapDispatchToProps = {
  fetchContentOps: fetchContentOpsById,
  resetEventActionStatus,
  updateContentOpsById
}

export default React.memo(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditContentOps)
)
